export default [
    {title: "Home", text: "Home"},
    {title: "Gardens", text: "Gardens"},
    {title: "About", text: "About"},
    {title: "Contact", text: "Contact"},
    {title: "Register", text: "Register Garden"},

];